module.exports = __webpack_public_path__ + "frontend/images/logos/small/small-green.png?943240af1f2c160232daca9450b62631";